import React from 'react';
import { ClockIcon, FilmIcon, HelpCircleIcon, MapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = [FilmIcon, HelpCircleIcon, MapIcon, ClockIcon];
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-canvas text-ink" data-id="element-128" data-mp="30j0vten9sx7b">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-129" data-mp="2vowj0erbpuyb">
        <p className="inline-block rounded-md bg-cta px-2 py-0.5 font-sub text-sm font-semibold text-white" data-id="element-130" data-mp="39guomfltt8pq">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight sm:text-3xl" data-id="element-131" data-mp="35in55czz9tau">
          Querés aprender contabilidad, registrar asientos, comprender impuestos
          y manejar las cuentas de un negocio,{' '}
          <span className="bg-cta-light px-1 text-cta" data-id="element-132" data-mp="1p456myqzzdci">
            pero no sabés por dónde empezar.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-ink/80" data-id="element-133" data-mp="jddbm61f48uh">
          Si estás comenzando desde cero, estudiando contabilidad o buscando
          mejorar tus conocimientos administrativos, probablemente conozcas
          alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-134" data-mp="x4i5eri3u6ww">
          {problems.map((problem, i) => {
          const Icon = ICONS[i];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-ink bg-white p-2.5 text-left" data-id="element-135" data-mp="123376vd08yng" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-cta text-white" aria-hidden="true" data-id="element-136" data-mp="1bzy1t365qewg">
                  <Icon size={16} data-id="element-137" data-mp="3dvi9ljp5mp9n" />
                </span>
                <div data-id="element-138" data-mp="3hvio14c970gp">
                  <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-139" data-mp="3hv0tqd95iwbf">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-ink/80 sm:text-sm" data-id="element-140" data-mp="k1fmzxfo1fdu">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}